var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 127,
    viewBox: "0 0 125 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_700_726)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_726",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 56,
    width: 71,
    height: 71
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111 56H40V127H111V56Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.75 56H40V91.5C40 111.106 55.8939 127 75.5 127C95.1059 127 111 111.106 111 91.5V56H93.25C83.447 56 75.5 63.947 75.5 73.75C75.5 63.947 67.553 56 57.75 56Z",
    fill: "#63C48B"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.75 106.659H33.1774C27.4475 106.659 22.8024 102.014 22.8024 96.2839V29.7012C22.8024 23.9712 27.4475 19.3262 33.1774 19.3262H72.0402C74.8009 19.3262 77.4478 20.4265 79.395 22.3836L90.1049 33.148C92.0392 35.0921 93.125 37.7231 93.125 40.4656V96.2838C93.125 102.014 88.48 106.659 82.75 106.659Z",
    fill: "#D7EEE1",
    stroke: "#151E19",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5726 18.7012V35.3547C71.5726 38.1161 73.8111 40.3547 76.5726 40.3547H93.75",
    stroke: "#151E19",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3226 60.5325C46.875 60.0404 68.0443 61.0242 75.6048 59.5479",
    stroke: "#151E19",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3226 74.8141C46.875 74.322 66.5322 72.8457 75.6048 74.8146",
    stroke: "#151E19",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3226 87.896C46.875 87.4039 55.4435 86.4213 62.5 87.8967",
    stroke: "#151E19",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2216 0V43.3071",
    stroke: "#48AD72",
    strokeWidth: 16.2105
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1049 21.6533L57.4597 21.6533",
    stroke: "#48AD72",
    strokeWidth: 16.2105
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_700_726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white",
    transform: "translate(40 56)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProject);
export default __webpack_public_path__ + "static/media/create-project.fc9872818cc3ada9533f8988d70a69b0.svg";
export { ForwardRef as ReactComponent };